/*eslint-disable*/
import React, { Component } from 'react'
import TitleBar from '../../components/titleBar/title_bar'
import ApprovalTable from '../../components/approvalComponent/approvalTable'
import { Input, Button } from 'semantic-ui-react'
import ApprovalModal from '../../components/approvalComponent/approvalModal'
import RejectModal from '../../components/approvalComponent/rejectModal'


export default class Approval extends Component {

    state = {
        searchValue: '',
        agApi: '',
        selectedOption: false,
        // reason: '',
        resError: false,
        rejectError: false,
        approvalData: []
    }
    handleSearch = (e, data) => {
        this.setState({
            searchValue: data.value
        })
    }

    getRowDatas = (childData) => {
        if (childData) {
            this.setState({
                approvalData: childData
            })
        }
    }
    exportBtn = () => {
        this.state.agApi.exportDataAsExcel({});
    }

    getInitialized = (prams) => {
        prams.api.paginationSetPageSize(Number(10))
        this.setState({ agApi: prams.api })
    }
    getSelectedOption = (data) => {
        this.setState({
            selectedOption: data
        })
    }

    handleChange = (e, data) => {
        if (data.name === 'approveReason') {
            if (data.value.length < 3) {
                this.setState({
                    resError: true
                })
            } else {
                if (this.state.approvalData.length > 0) {
                    let finalData = []
                    this.state.approvalData.map((o, i) => {
                        let temp = {}
                        temp.approvalStatus = '3'
                        temp.jobCardId = o.jobCardId.toString()
                        temp.remarks = data.value
                        finalData[i] = temp
                    })
                    this.setState({
                        resError: false,
                        approvalData: finalData
                    })
                }
            }
        } else if (data.name === 'rejectReason') {
            if (data.value.length < 3) {
                this.setState({
                    rejectError: true
                })
            } else {
                if (this.state.approvalData.length > 0) {
                    let finalData = []
                    this.state.approvalData.map((o, i) => {
                        let temp = {}
                        temp.approvalStatus = '4'
                        temp.jobCardId = o.jobCardId.toString()
                        temp.remarks = data.value
                        finalData[i] = temp
                    })
                    this.setState({
                        rejectError: false,
                        approvalData: finalData
                    })
                }
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <TitleBar title="Approvals" hiddenNew={true}>
                    <Input size="mini" icon={{ name: 'search', circular: true }} onChange={this.handleSearch} className="mr-1 searchInput" placeholder="Search..." />
                    {/* <Button size="tiny" onClick={this.exportBtn} basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> Export</Button> */}
                    {this.state.selectedOption ? <>
                        {/* <Button size="tiny" basic color="green" >Approve</Button> */}
                        <ApprovalModal appLists={this.state.approvalData} resError={this.state.resError} handleChange={this.handleChange} />
                        {/* <Button size="tiny" basic color="red">Reject</Button> */}
                        <RejectModal appLists={this.state.approvalData} resError={this.state.rejectError} handleChange={this.handleChange} />
                    </> : ''}
                </TitleBar>
                <ApprovalTable
                    linkProps={this.props}
                    searchValue={this.state.searchValue}
                    onGridReady={this.getInitialized}
                    onSelected={this.getSelectedOption}
                    selectedRowData={this.getRowDatas}
                />

            </React.Fragment>
        )
    }
}
